import {getDeviceType} from "@/plugins/Helpers";
import {sha256} from "js-sha256";
import {getRecaptchaScore, isRecaptchaRejected} from "@/plugins/RecaptchaStore";

document.addEventListener('magazineFormSentEvent', (e) => {
    if (isRecaptchaRejected()) {
        if (!window.env?.IS_PRODUCTION) {
            console.log('Event not pushed to dataLayer: reCAPTCHA rejected.', 'lead_magazine');
        }
        return;
    }

    const ev = e as CustomEvent;
    /** @ts-ignore */
    window.dataLayer = window.dataLayer || [];

    const dataLayerData = {
        'event': 'lead_magazine',
        'lead_country': window.locale,
        'lead_device_category': getDeviceType(),
        /** @ts-ignore */
        'lead_product_category': window.analytics_label,
    };

    /** @ts-ignore */
    if (typeof ev.email !== 'undefined' && ev.email !== null) {
        /** @ts-ignore */
        dataLayerData.sha256_email_address = sha256(ev.email);
    }

    /** @ts-ignore */
    window.dataLayer.push(dataLayerData);
    if (!window.env?.IS_PRODUCTION) {
        console.log('Pushing event to dataLayer: ', dataLayerData);
    }
    window.beacon.add(
        'lead_magazine',
        {
            entity: {
                type: 'magazine_form',
            },
            url: window.location.href,
            agent: navigator.userAgent,
            language: window.locale,
            'lead_device_category': getDeviceType(),
            /** @ts-ignore */
            'lead_product_category': window.analytics_label,
        }
    );
    window.beacon.send();
});

document.addEventListener('contactFormSentEvent', (e) => {
    if (isRecaptchaRejected()) {
        if (!window.env?.IS_PRODUCTION) {
            console.log('Event not pushed to dataLayer: reCAPTCHA rejected.', 'contactFormSentEvent');
        }
        return;
    }

    const ev = e as CustomEvent;

    window.beacon.add(
        /** @ts-ignore */
        'universal-contact-form',
        {
            entity: {
                type: ev.detail.form_type ?? 'contact_form',
            },
            /** @ts-ignore */
            order_id: e.order_id,
            lead_device_category: getDeviceType(),
            /** @ts-ignore */
            lead_product_category: window.analytics_label,
        }
    );
    window.beacon.send();

    const cookieName = 'pickawood_has_contactrequest';
    const isCookieSet = window.Cookies.get(cookieName) !== null
        && typeof window.Cookies.get(cookieName) !== 'undefined';
    if (isCookieSet) {
        if (!window.env?.IS_PRODUCTION) {
            console.log('Event not pushed to dataLayer: lead_contact_request. Cookie is set.');
        }
        return;
    }

    /** @ts-ignore */
    window.dataLayer = window.dataLayer || [];

    const dataLayerData = {
        event: 'lead_contact_request',
        lead_country: window.locale,
        lead_device_category: getDeviceType(),
        /** @ts-ignore */
        lead_product_category: window.analytics_label,
    };

    /** @ts-ignore */
    if (typeof ev.email !== 'undefined' && ev.email !== null) {
        /** @ts-ignore */
        dataLayerData.sha256_email_address = sha256(ev.email);
    }

    /** @ts-ignore */
    window.dataLayer.push(dataLayerData);
    if (!window.env?.IS_PRODUCTION) {
        console.log('Pushing event to dataLayer: ', dataLayerData);
    }

    window.Cookies.set(cookieName, 1, 365, '/');
});

document.addEventListener('searchEvent', (e) => {
    const ev = e as CustomEvent;
    const searchParams = new URLSearchParams(document.location.search);
    if (!searchParams.has('q')) {
        return;
    }

    /** @ts-ignore */
    window.dataLayer = window.dataLayer || [];
    const dataLayerData = {
        event: 'search',
        search_query: searchParams.get('q')!.toLowerCase(),
        search_results_cms: ev.detail.cms,
        search_results_pfc: ev.detail.products,
        search_results: ev.detail.cms + ev.detail.products,
        search_lang: window.locale,
    };
    /** @ts-ignore */
    window.dataLayer.push(dataLayerData);
    if (!window.env?.IS_PRODUCTION) {
        console.log('Pushing event to dataLayer: ', dataLayerData);
    }
});

const getLeadConfigurationData = (ev: CustomEvent) => {
    let price = ev.detail.product_price;
    let vatValue = 1.16;
    if (window.locale === 'ch') {
        vatValue = 1.077;
    } else if (window.locale === 'fr') {
        vatValue = 1.20;
    }
    price = Math.round((price / vatValue) * 100) / 100;

    return {
        lead_country: window.locale,
        lead_device_category: getDeviceType(),
        /** @ts-ignore */
        lead_product_category: ev.detail.product_type,
        conversionValue: price,
    };
};

const saveLeadConfigurationEvent = (ev: CustomEvent) => {
    if (isRecaptchaRejected()) {
        if (!window.env?.IS_PRODUCTION) {
            console.log('Event not pushed to dataLayer: reCAPTCHA rejected.', 'lead_configuration_saved');
        }
        return;
    }

    const cookieName = 'pickawood_has_configuration';
    const isCookieSet = window.Cookies.get(cookieName) !== null
        && typeof window.Cookies.get(cookieName) !== 'undefined';
    if (isCookieSet) {
        if (!window.env?.IS_PRODUCTION) {
            console.log('Event not pushed to dataLayer: lead_configuration_saved. Cookie is set.');
        }
        return;
    }

    /** @ts-ignore */
    window.dataLayer = window.dataLayer || [];

    const commonData = getLeadConfigurationData(ev);

    if (commonData.conversionValue > 5000.00) {
        console.log('Event not pushed to dataLayer: lead_configuration_saved. Price is too high (> 5000).');
        return;
    }

    const dataLayerData = {
        event: 'lead_configuration_saved',
        ...commonData,
        configuration: ev.detail.configuration,
        parent_configuration_id: ev.detail.parent_configuration_id,
        configuration_id: ev.detail.configuration_id ? Number(ev.detail.configuration_id) : null,
        recaptcha_score: getRecaptchaScore(),
        lead_location: 'pfc',
    };

    /** @ts-ignore */
    if (typeof ev.detail.email !== 'undefined' && ev.detail.email !== null) {
        /** @ts-ignore */
        dataLayerData.sha256_email_address = sha256(ev.detail.email);
    }

    /** @ts-ignore */
    window.dataLayer.push(dataLayerData);
    if (!window.env?.IS_PRODUCTION) {
        console.log('Pushing event to dataLayer: ', dataLayerData);
    }

    window.Cookies.set(cookieName, 1, 365, '/');
};

document.addEventListener('productConfigurationAfterSave', (e) => {
    const ev = e as CustomEvent;

    /** @ts-ignore */
    window.dataLayer = window.dataLayer || [];

    const commonData = getLeadConfigurationData(ev);

    const dataLayerData = {
        event: ev.detail.event,
        configuration_count: ev.detail.configuration_count,
        configuration_id: ev.detail.configuration_id ? Number(ev.detail.configuration_id) : null,
        ...commonData,
    };

    /** @ts-ignore */
    if (typeof ev.detail.email !== 'undefined' && ev.detail.email !== null) {
        /** @ts-ignore */
        dataLayerData.sha256_email_address = sha256(ev.detail.email);
    }

    /** @ts-ignore */
    window.dataLayer.push(dataLayerData);
    if (!window.env?.IS_PRODUCTION) {
        console.log('Pushing event to dataLayer: ', dataLayerData);
    }
});

document.addEventListener('aiDesignLeadSubmittedEvent', (e) => {
    if (isRecaptchaRejected()) {
        if (!window.env?.IS_PRODUCTION) {
            console.log('Event not pushed to dataLayer: reCAPTCHA rejected.', 'ai_lead_submitted');
        }
        return;
    }

    const ev = e as CustomEvent;

    window.beacon.add(
        /** @ts-ignore */
        'universal-contact-form',
        {
            entity: {
                type: 'ai_design_form',
            },
            lead_device_category: getDeviceType(),
            /** @ts-ignore */
            lead_product_category: window.analytics_label,
            ai_furniture_type: ev.detail?.furnitureType ?? null,
            ai_style: ev.detail?.style ?? null,
        }
    );
    window.beacon.send();

    /** @ts-ignore */
    window.dataLayer = window.dataLayer || [];

    const dataLayerData = {
        event: 'ai_lead_submitted',
        lead_country: window.locale,
        lead_device_category: getDeviceType(),
        /** @ts-ignore */
        lead_product_category: window.analytics_label,
        ai_furniture_type: ev.detail?.furnitureType ?? null,
        ai_style: ev.detail?.style ?? null,
    };

    if (typeof ev.detail?.email === 'string' && ev.detail.email !== '') {
        /** @ts-ignore */
        dataLayerData.sha256_email_address = sha256(ev.detail.email);
    }

    /** @ts-ignore */
    window.dataLayer.push(dataLayerData);
    if (!window.env?.IS_PRODUCTION) {
        console.log('Pushing event to dataLayer: ', dataLayerData);
    }
});

document.addEventListener('productSpecialWishModalSentEvent', (e) => {
    const ev = e as CustomEvent;
    saveLeadConfigurationEvent(ev);

    window.beacon.add(
        /** @ts-ignore */
        'special-wish-form',
        {
            entity: {
                type: 'special_wish_form',
            },
            /** @ts-ignore */
            product_id: ev.detail.product_id,
            lead_device_category: getDeviceType(),
            /** @ts-ignore */
            lead_product_category: window.analytics_label,
        }
    );
    window.beacon.send();
});

document.addEventListener('productSaveModalSentEvent', (e) => {
    const ev = e as CustomEvent;
    saveLeadConfigurationEvent(ev);

    window.beacon.add(
        /** @ts-ignore */
        'save-product-modal-form',
        {
            entity: {
                type: 'save_modal_form',
            },
            /** @ts-ignore */
            product_id: ev.detail.product_id,
            lead_device_category: getDeviceType(),
            /** @ts-ignore */
            lead_product_category: window.analytics_label,
        }
    );
    window.beacon.send();
});
